import styled from 'styled-components'
import { Typography } from '@astro-ui/components'

const SidebarEmptyState = () => (
  <Container role="status" aria-live="polite">
    <IllustrationWrapper>
      {/* Simple SVG illustration for empty search state */}
      <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <circle cx="24" cy="24" r="16" stroke="#CAD3E1" strokeWidth="2.5" fill="none" />
        <line
          x1="35"
          y1="35"
          x2="46"
          y2="46"
          stroke="#CAD3E1"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <line
          x1="19"
          y1="24"
          x2="29"
          y2="24"
          stroke="#CAD3E1"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </IllustrationWrapper>
    <Typography
      variant="body2"
      align="center"
      style={{ color: '#8C9AAD', lineHeight: '20px', padding: '0 8px' }}
    >
      Menu tidak ditemukan
    </Typography>
  </Container>
)

export default SidebarEmptyState

/* ─── Styled Components ─────────────────────────────────────────────────────── */

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 16px 16px;
  gap: 12px;
`

const IllustrationWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.7;
`
